import React from 'react'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import TreatmentDate from '../../../components/TreatmentDate'
import HealthcareTeam from '../../../components/HealthcareTeam'
import TeamAddress from '../../../components/TeamAddress'
import { injectIntl } from 'react-intl'
// import { caseSelector } from '../../../../redux/selectors'
import { caseSelector } from '../../../redux/selectors'
import { compose } from 'recompose'
import { connect, useDispatch } from 'react-redux'
import { Button } from '@material-ui/core'
import { hideModal } from '../../../redux/actions'

const RequiredQuestions = ({ message, intl }) => {

  const dispatch = useDispatch()

  const onButtonClick = () => {
    dispatch(hideModal())
  }

  return (

      <Grid container direction="column" item xs={12} style={{ padding: '40px' }}>

        <Grid item style={{ alignSelf: 'center', marginBottom: '32px'  }}>
          <Typography 
            variant="h2" 
            data-testid="required-questions-info-title"
            style={{ fontWeight: '400', textAlign: 'center'}}
          >
            {intl.formatMessage({ id: 'app.requiredQuestions.title' })}
          </Typography>
        </Grid>
        <Grid item style={{ marginBottom: '32px' }}>
          <Typography variant="body1">{message}</Typography>
        </Grid>
        <Button
          data-testid="button-required-questions-close"
          variant='contained'
          color='primary'
          size='large'
          style={{ alignSelf: 'center' }}
          onClick={onButtonClick}
        >
          {intl.formatMessage({ id: 'app.requiredQuestions.buttonTitle' })}
        </Button>
      </Grid>
  )
}

const mapStateToProps = (state, ownProps) => ({
  data: caseSelector(state)
})

const mapDispatchToProps = (dispatch, ownProps) => ({})

const enhance = compose(connect(mapStateToProps, mapDispatchToProps), injectIntl)

export default enhance(RequiredQuestions)
